// IoT Devices Hook
import { useQuery } from '@tanstack/react-query';
import { iotApiService } from '../services/iotApiService';

export const useIotDevices = (enabled = true) => {
  return useQuery({
    queryKey: ['iot-devices'],
    queryFn: async () => {
      const response = await iotApiService.getDevices();
      return response.data;
    },
    enabled: enabled,
    refetchInterval: 5000, // Refresh every 5 seconds
    retry: 2, // Retry failed requests twice
  });
};
